import React from 'react';
import Icon from '../../../components/AppIcon';
import RequirementCard from './RequirementCard';

const KanbanColumn = ({ 
  status, 
  requirements, 
  onCardSelect, 
  selectedCard, 
  onDrop, 
  onDragOver, 
  onDragStart, 
  onDragEnd, 
  draggingCard 
}) => {
  const getStatusConfig = (status) => {
    switch (status) {
      case 'Proposed':
        return {
          title: 'Proposed',
          icon: 'FileText',
          color: 'text-muted-foreground',
          bgColor: 'bg-muted/10',
          borderColor: 'border-muted'
        };
      case 'Analyzing':
        return {
          title: 'Analyzing',
          icon: 'Search',
          color: 'text-warning',
          bgColor: 'bg-warning/10',
          borderColor: 'border-warning/20'
        };
      case 'Fit':
        return {
          title: 'Fit',
          icon: 'CheckCircle2',
          color: 'text-success',
          bgColor: 'bg-success/10',
          borderColor: 'border-success/20'
        };
      case 'Gap':
        return {
          title: 'Gap',
          icon: 'AlertCircle',
          color: 'text-destructive',
          bgColor: 'bg-destructive/10',
          borderColor: 'border-destructive/20'
        };
      case 'Approved':
        return {
          title: 'Approved',
          icon: 'CheckCircle',
          color: 'text-primary',
          bgColor: 'bg-primary/10',
          borderColor: 'border-primary/20'
        };
      default:
        return {
          title: status,
          icon: 'Circle',
          color: 'text-muted-foreground',
          bgColor: 'bg-muted/10',
          borderColor: 'border-muted'
        };
    }
  };

  const config = getStatusConfig(status);
  const columnRequirements = requirements?.filter(req => req?.status === status);

  const handleDrop = (e) => {
    e?.preventDefault();
    const cardId = e?.dataTransfer?.getData('text/plain');
    onDrop(cardId, status);
  };

  const handleDragOver = (e) => {
    e?.preventDefault();
    onDragOver(status);
  };

  return (
    <div className="flex flex-col h-full">
      {/* Column Header */}
      <div className={`flex items-center justify-between p-4 border-b border-border ${config?.bgColor}`}>
        <div className="flex items-center space-x-2">
          <Icon 
            name={config?.icon} 
            size={16} 
            className={config?.color}
          />
          <h3 className={`text-sm font-semibold ${config?.color}`}>
            {config?.title}
          </h3>
          <span className={`px-2 py-1 text-xs font-medium rounded-full bg-background border ${config?.borderColor} ${config?.color}`}>
            {columnRequirements?.length}
          </span>
        </div>
        
        <button className={`p-1 rounded hover:bg-background/50 nav-transition ${config?.color}`}>
          <Icon name="MoreHorizontal" size={16} />
        </button>
      </div>
      {/* Cards Container */}
      <div 
        className="flex-1 p-4 space-y-3 overflow-y-auto min-h-0"
        onDrop={handleDrop}
        onDragOver={handleDragOver}
      >
        {columnRequirements?.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-8 text-center">
            <Icon 
              name="Package" 
              size={32} 
              className="text-muted-foreground/50 mb-2"
            />
            <p className="text-sm text-muted-foreground">
              No requirements in {config?.title?.toLowerCase()}
            </p>
          </div>
        ) : (
          columnRequirements?.map((requirement) => (
            <RequirementCard
              key={requirement?.id}
              requirement={requirement}
              onSelect={onCardSelect}
              isSelected={selectedCard?.id === requirement?.id}
              onDragStart={onDragStart}
              onDragEnd={onDragEnd}
              isDragging={draggingCard?.id === requirement?.id}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default KanbanColumn;